import type { QueryClient } from "@tanstack/react-query";
import { Link, Outlet, createRootRouteWithContext } from "@tanstack/react-router";

import { LogoMark } from "../components/logo";
import { ToastProvider } from "../components/toast";
import { TooltipProvider } from "../components/ui/tooltip";
import { useDocumentHead } from "../lib/head";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  // What a page without its own head() shows: the signed-in app, the login.
  head: () => ({
    meta: [
      { title: "Listou · Listes d'envies à partager" },
      {
        name: "description",
        content:
          "Créez votre liste de Noël, de naissance, de mariage ou d'anniversaire. Vos proches réservent un cadeau sans vous gâcher la surprise.",
      },
    ],
  }),
  component: () => (
    <ToastProvider>
      <TooltipProvider delay={300}>
        <DocumentHead />
        <Outlet />
      </TooltipProvider>
    </ToastProvider>
  ),
  notFoundComponent: NotFound,
});

function NotFound() {
  return (
    <main className="mx-auto grid max-w-md justify-items-start gap-4 px-4 py-24">
      <LogoMark className="size-12" />
      <h1 className="text-4xl font-semibold">Cette page n'existe pas</h1>
      <p className="text-lg text-muted">
        Le lien est peut-être incomplet, ou la liste a été retirée par ses créateurs.
      </p>
      <Link to="/" className="btn">
        Retour à l'accueil
      </Link>
    </main>
  );
}

/**
 * Rendered before the page so its effect runs first: a page that still sets
 * `document.title` itself (from data it loads later) gets the last word.
 */
function DocumentHead() {
  useDocumentHead();
  return null;
}
